import * as types from '../mutation-types'
import { api } from '@/modules/api'

const state = {
  tags: [],
  tagsByType: []
}

const getters = {
  tags: state => state.tags,
  tagsByType: state => state.tagsByType
}

const actions = {
  async getTag ({ commit }) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.get(api.tag.getTag())
      commit(types.GET_TAG, response.data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Error on getting Killer Features')
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async getTagByType ({ commit }, type) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.get(api.tag.getTagByType(type))
      commit(types.GET_TAG_BY_TYPE, response.data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Error on getting Killer Features')
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async postTag ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.post(api.tag.postTag(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Killer Feature was successfully created!')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Error on creating Killer Feature')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async putTag ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.tag.putTag(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Killer Feature was successfully changed!')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Error on change Killer Feature')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async putTagType ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.tag.putTagType(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Killer Feature List was successfully updated!')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Error on change Killer Feature List')
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async deleteTag ({ commit }, id) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios({ method: 'delete', url: api.tag.deleteTag(id) })
      commit(types.CREATE_SUCCESS_MESSAGE, 'Killer Feature was successfully deleted!')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Error on delete Killer Feature')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

const mutations = {
  [types.GET_TAG] (state, { tags }) {
    state.tags = tags
  },
  [types.GET_TAG_BY_TYPE] (state, { tags }) {
    state.tagsByType = tags
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/tag.js